__webpack_require__.p = "/ai-readiness-assessment/";